import { HiOutlineMinus, HiOutlinePlus } from 'react-icons/hi'

interface GetQuantityProps {
    isWaiter: boolean;
    qty: number,
    handleDecrease: () => void;
    handleIncrease: () => void;
}

export default function GetQuantity({ isWaiter, qty, handleDecrease, handleIncrease }: GetQuantityProps) {
    const isDecreaseDisabled = !isWaiter && qty === 1;
    return (
        <div className="flex items-center gap-x-1">
            <div
                className="bg-white w-[22px] h-[22px] md:w-[26px] md:h-[26px] rounded-full flex items-center justify-center shadow-qty text-primary cursor-pointer"
            >
                <HiOutlineMinus size={18} className="text-red-1 font-bold cursor-pointer" onClick={!isDecreaseDisabled ? handleDecrease : undefined} />
            </div>
            <input
                type="text"
                value={qty}
                className="max-w-[30px] h-[30px] text-black p-0 text-center flex items-center justify-center focus:ring-0 focus:outline-none border-none bg-transparent"
                readOnly
            />
            <div
                className="bg-white w-[22px] h-[22px] md:w-[26px] md:h-[26px] rounded-full flex items-center justify-center shadow-qty text-primary cursor-pointer"
                onClick={handleIncrease}
            >
                <HiOutlinePlus size={18} />
            </div>
        </div>
    )
}
